export default {
    en: {
        COMPETITIONS: "Competitions",
        SUBDOMAIN: "Subdomain",
        PLAYERS: "Players",
        START: "Start",
        END: "End",
    }
};
